import S from 'common/service/sanctuary';

export default class ConfigService {
  constructor(config) {
    this.config = config;
  }

  getConfig(...names) {
    if (names && names.length) {
      return S.props(names, this.config);
    }

    return this.config;
  }
}
